<template>
  <v-container>
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-row>
    </v-overlay>
    <v-col>
      <v-row>
        <h3 v-if="!LoginMode">{{ $t("twoFactorScanCodeInfo") }}</h3>
        <h3 v-else>{{ $t("enterOTPCode") }}</h3>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-img v-if="!LoginMode" mb2 contain :width="171" :height="171" :src="qrCode"></v-img>
          <v-icon v-else :size="90">mdi-cellphone-lock</v-icon>
        </v-col>
        <v-col cols="6">
          <v-text-field
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            prepend-icon="mdi-lock"
            ref="loginOtpField"
            v-model="twoFactorPin"
            :label="$t('password')"
            :type="showPass ? 'text' : 'password'"
            autocomplete="off"
            :rules="[rules.required]"
            @keyup.enter="LoginMode ? sendOTPPin() : enableTwoFactorAuth()"
            :counter="6"
            :maxlength="6"
            @click:append="showPass = !showPass"
            ma-0
            pa-0
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <mybtn v-if="!LoginMode" :lable="$t('activateOTP')" @click="enableTwoFactorAuth"></mybtn>
        <mybtn v-else lable="Login" @click="sendOTPPin"></mybtn>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: "OTPLogin",
  data: () => ({
    rules: {
      required: (v) => !!v || "Erforderlich."
    },
    showPass: false,
    twoFactorPin: "",
    loaderOverlay: false
  }),
  props: {
    secret: Object,
    qrCode: String,
    LoginMode: Boolean,
    PIN: String
  },
  mounted: function () {
    this.$nextTick(() => this.$refs.loginOtpField.focus());
  },
  methods: {
    enableTwoFactorAuth: async function () {
      let token = this.twoFactorPin;
      let secretAndToken = {
        userId: this.$store.getters["user/user"].SAPEmpId,
        token,
        secret: this.secret
      };
      this.loaderOverlay = true;
      await this.$store
        .dispatch("user/enableTwoFactorAuth", secretAndToken)
        .then((resp) => {
          if (resp.data.success) {
            this.$eventHub.$emit("showSuccess", this.$t("successfullyTransmitted"));
            this.twoFactorEnabled = true;
            this.loaderOverlay = false;
            this.$emit("success");
          } else {
            this.$eventHub.$emit("showError", this.$t(err.response.data.error));
          }
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", this.$t(err.response.data.error));
          }
        });
      this.loaderOverlay = false;
    },
    sendOTPPin: async function () {
      let otpLoginObject = {
        otpPin: this.twoFactorPin,
        pin: this.PIN
      };
      this.loaderOverlay = true;
      await this.$store
        .dispatch("user/loginOTP", otpLoginObject)
        .then((resp) => {
          this.$eventHub.$emit("showSuccess", this.$t("successfullyTransmitted"));
          this.twoFactorEnabled = true;
          this.loaderOverlay = false;
          this.$emit("success");
        })
        .catch((err) => {
          this.loaderOverlay = false;
          this.pin = "";
          if (err.response.status != 200) {
            if (err.response.data.error) this.$eventHub.$emit("showError", this.$t(err.response.data.error), "bottom", "right");
            else {
              this.$eventHub.$emit("showError", this.$t("unexpectedError"), "bottom", "right");
            }
          }
        });
    }
  }
};
</script>

<style></style>
